<p-toast></p-toast>
<div class="flex flex-column" *ngIf="fc">
  <p-toolbar>
    <div class="p-toolbar-group-start">
      <ng-container *ngIf="fc.LoadedForm">
        <CustomTitle [title]="fc.LoadedForm.nombre"
          styleClass="font-principal app-title-page-color font-medium font-20" />
      </ng-container>
    </div>
    <div class="p-toolbar-group-center">
    </div>
    <div class="p-toolbar-group-end gap-1">
      @if(referencias && referencias.length > 0) {
        <button pButton (click)="op.toggle($event)" icon="pi pi-share-alt" [label]="'common.referencias' | translate"
          class="button-edit p-button-outlined" size="small" severity="help"></button>
  
        <p-overlayPanel #op>
          <p-listbox [options]="referencias" optionLabel="nombre" [style]="{'width':'15rem'}"
            [listStyle]="{'max-height': '220px'}" (onClick)="openForm($event)"/>
        </p-overlayPanel>
      }

      <ng-container *ngIf="fc.LoadedForm; else noFormLoaded">
        <button pButton type="button" (click)="openModal()" [label]="'form.button.actualizar' | translate"
          icon="pi pi-save" size="small" class="button-edit p-button-outlined"></button>
      </ng-container>
      <ng-template #noFormLoaded>
        <button pButton type="button" (click)="openModal()" [label]="'form.button.guardar' | translate"
          icon="pi pi-file-edit" size="small" class="button-edit p-button-outlined p-button-success"></button>
      </ng-template>
    </div>
  </p-toolbar>

  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p-dialog [modal]="true" [(visible)]="displayModal" [autoZIndex]="true" [draggable]="false" [resizable]="true"
      [maximizable]="true" [breakpoints]="{'960px': '100vw'}" [style]="{width: '60vw'}" [draggable]="false">

      <ng-template pTemplate="header">
        <CustomTitle [title]="form ? ('form.button.actualizar' | translate) : ('form.button.guardar' | translate)" />
      </ng-template>

      <ng-template pTemplate="content">
        <main class="grid formgrid p-fluid">
          <div class="field col-12">
            <label for="name" class="ml-3">{{'components.app-form-save-manager.name' | translate}}</label>
            <input pInputText id="name" formControlName="name" type="text" class="w-full" aria-describedby="name-help">
            <ng-container *ngIf="formGroup.get('name')?.touched && formGroup.get('name')?.invalid">
              <app-form-group-error-message [control]="formGroup.get('name')"></app-form-group-error-message>
            </ng-container>
          </div>

          <div class="field col-12">
            <label for="description" class="ml-3">{{'components.app-form-save-manager.description' | translate}}</label>
            <textarea pInputTextarea id="description" formControlName="description" type="text" class="w-full"
              aria-describedby="description-help"></textarea>
            <ng-container *ngIf="formGroup.get('description')?.touched && formGroup.get('description')?.invalid">
              <app-form-group-error-message [control]="formGroup.get('description')"></app-form-group-error-message>
            </ng-container>
          </div>
          <div class="field col-12 md:col-6">
            <label for="category" class="ml-3">{{ 'components.app-form-save-manager.category' | translate }}</label>
            <p-dropdown id="category" formControlName="category" appendTo="body" [editable]="true"
              optionValue="descripcion" class="w-full" [options]="categories" optionLabel="descripcion"
              aria-describedby="description-help"></p-dropdown>
            <ng-container *ngIf="formGroup.get('category')?.touched && formGroup.get('category')?.invalid">
              <app-form-group-error-message [control]="formGroup.get('category')" />
            </ng-container>
          </div>
        </main>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton type="submit"
          [label]="form ? ('form.button.actualizar' | translate) : ('form.button.guardar' | translate)"
          icon="pi pi-save" [disabled]="!ls.hasRole(role.ADMIN_FORM)" class="tax-app-button"></button>
      </ng-template>
    </p-dialog>
  </form>
</div>